import getKeyCloakAdminClient from "@onesolution/utils/userSync/keycloakAdminClient";
import { createServerFn } from "@tanstack/react-start";
import z from "zod";

export const checkSso = createServerFn()
	.validator(
		z.object({
			email: z.string(),
		}),
	)
	.handler(async ({ data }) => {
		const kk = await getKeyCloakAdminClient();

		const client = await kk.clients.find({
			clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
		});

		const clientUniqueId = client?.[0]?.id;

		if (!clientUniqueId) return false;

		const s = await kk.clients.listSessions({
			id: clientUniqueId,
		});

		return s.some((session) => session.username === data.email);
	});
